import { devToolsSections } from './devToolsSections'
import { SidebarCard } from './styled-components'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import SidebarItem from '@/containers/DevToolsNew/DevToolsLayout/DevToolsSidebarItem'


const DevToolsSidebar = () => {
  const { t } = useTranslation('devToolsNew')
  const authData = useSelector(selectAuthData)
  const visibleSections = devToolsSections.filter(({ isVisible }) => !isVisible || isVisible(authData))

  return (
    <SidebarCard>
      {visibleSections.map(({ key, labelKey, Icon }) => (
        <SidebarItem key={key} to={`/dev-tools-v2/${key}`} label={t(labelKey)} Icon={Icon} />
      ))}
    </SidebarCard>
  )
}

export default DevToolsSidebar
